import { render, staticRenderFns } from "./TxRendererScreenshotArea.vue?vue&type=template&id=608debe6&scoped=true&"
import script from "./TxRendererScreenshotArea.vue?vue&type=script&lang=js&"
export * from "./TxRendererScreenshotArea.vue?vue&type=script&lang=js&"
import style0 from "./TxRendererScreenshotArea.vue?vue&type=style&index=0&id=608debe6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608debe6",
  null
  
)

export default component.exports